import React, { useState, useRef, FC } from 'react';
import { Tooltip } from 'antd';
import { useAntLocale } from '@fuxi/eevee-hooks';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames/bind';
import { ContactType } from '@commonPackage/constants';

import { toContactPage } from '@portalCommon/utils';
import { RouterConfigEnum } from '@portalCommon/constants';
import { ZH } from '@yaotai/common-utils';
import qrcode from '@/assets/home/qrcode.png';

import styles from './index.module.less';

const cx = classnames.bind(styles);

interface Props {}

const EMAIL = 'fuxi@service.netease.com';

export const Contact: FC<Props> = () => {
  const { t } = useTranslation();
  const { language } = useAntLocale();
  const [text, setText] = useState<string>(t('footer.copy'));
  const emailRef = useRef<HTMLInputElement>(null);

  const copy = () => {
    emailRef.current && emailRef.current.select();
    document.execCommand('copy');
    setTimeout(() => {
      setText(t('footer.copySuccess'));
    }, 51);
  };

  return (
    <div
      style={{
        position: 'relative',
      }}>
      <section id="contact" className={cx('contact')}>
        <div className={cx('wrapper')}>
          <div className={cx('column', 'column-left')}>
            <div className={cx('p')}>
              <h3
                className={cx('contact-title', 'contact-us')}
                onClick={() => {
                  toContactPage({
                    contactType: ContactType.cooperation,
                    isMain: import.meta.env.VITE_MAIN === 'true',
                  });
                }}>
                {t('footer.contactUs')}
              </h3>
            </div>
            <div className={cx('p')}>{t('footer.services')}</div>
            {language === ZH && <div className={cx('p')}>电话：（0571）89852163转21951</div>}
            <div className={cx('p')}>
              {language === ZH && '邮箱：'}fuxi@service.netease.com
              <input ref={emailRef} type="text" defaultValue={EMAIL} className={cx('emailHide')} />
              <Tooltip
                placement="right"
                title={text}
                color="#2F3D48"
                mouseLeaveDelay={1}
                onOpenChange={() =>
                  setTimeout(() => {
                    setText(t('footer.copy'));
                  }, 50)
                }>
                <div className={cx('copyBtn')} onClick={copy}></div>
              </Tooltip>
            </div>
          </div>
          <div className={cx('column', 'column-medium')}>
            <div>
              <h3 className={cx('contact-title', 'about-us')}>{t('footer.aboutUs')}</h3>
            </div>
            <div className={cx('p')}>{t('footer.onlineVirtual')}</div>
            <div className={cx('p')}>{t('footer.location')}</div>
          </div>
          <div className={cx('column', 'column-right')}>
            <div>
              <h3 className={cx('contact-title', 'follow-us')}>{t('footer.follow')}</h3>
            </div>
            <img className={cx('qrcode')} src={qrcode} alt={t('footer.NetEaseFuxi')} />
            <div className={cx('p')}>{t('footer.NetEaseFuxi')}</div>
          </div>
          <div className={cx('column', 'column-right')}>
            <div>
              <h3 className={cx('contact-title', 'common-problem')}>{t('footer.helpCenter')}</h3>
            </div>
            <p
              className={cx('common-problem-content')}
              onClick={() => {
                window.location.href = `${window.location.origin}/${RouterConfigEnum.SeoPostSlug}/`;
              }}>{`${t('footer.commonProblem')} >`}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
